module.exports = __webpack_public_path__ + "img/jm_white.189d4427.png";